import AksaraCharGrid from "./AksaraCharGrid.tsx";

const GridSection =({
  title,
  subtitle,
  chars,
  emptyText,
  getBoxStyle,
  getBarStyle,
  onCharClick,
  emptyAtStart = 0,
  emptyAtEnd = 0,
  className = "",
  darkMode = false,
  dividerClassName = "",
}) => {
  return (
    <div className={className}>
      {title && (
        <div
          className={`text-xl font-semibold mb-1 px-3 md:px-6 lg:px-8 ${darkMode ? "text-gray-200" : "text-gray-700"}`}
          style={{ fontFamily: "DIN Next Rounded" }}
        >
          {title}
        </div>
      )}
      {subtitle && (
        <span className={`text-xs ${darkMode ? "text-gray-400" : "text-gray-500"}`}>{subtitle}</span>
      )}
      {title && <hr className={`mb-4 ${dividerClassName} ${darkMode ? "border-gray-600" : "border-gray-400"}`} />}
      {chars.length === 0 && (
        <div
          className={`text-sm text-center mb-2 ${darkMode ? "text-gray-500" : "text-gray-400"}`}
          style={{ fontFamily: "DIN Next Rounded" }}
        >
          {emptyText}
        </div>
      )}
      <AksaraCharGrid
        chars={chars}
        getBoxStyle={getBoxStyle}
        getBarStyle={getBarStyle}
        onCharClick={onCharClick}
        emptyAtStart={emptyAtStart}
        emptyAtEnd={emptyAtEnd}
        darkMode={darkMode}
      />
    </div>
  );
}

export default GridSection;